import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import { NgbDropdown, NgbDropdownMenu, NgbDropdownToggle } from '@ng-bootstrap/ng-bootstrap';
import {
  DEFAULT_DEVICE_HEALTH_STATE,
  DEVICE_HEALTH_STATE_OPTIONS,
  DeviceHealthState,
} from './device-health-state.config';

@Component({
  selector: 'era-device-health-state-filter',
  templateUrl: './device-health-state-filter.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgbDropdown, NgbDropdownMenu, NgbDropdownToggle],
})
export class DeviceHealthStateFilterComponent {
  public readonly options = DEVICE_HEALTH_STATE_OPTIONS;

  public readonly selected = input<DeviceHealthState>(DEFAULT_DEVICE_HEALTH_STATE);
  public readonly selectedChange = output<DeviceHealthState>();

  public isSelected(state: DeviceHealthState): boolean {
    return this.selected() === state;
  }

  public readonly selectionLabel = computed(
    () => this.options.find((option) => option.type === this.selected())?.title ?? 'All device states'
  );

  public select(state: DeviceHealthState): void {
    this.selectedChange.emit(state);
  }
}
